<!-- 潜在客户 -->
<template>
    <el-card class="potential-client fitness-el-button-ui">
        <template>
            <el-button type="primary" @click="createMshpContract">{{ $t('Member.add') }}</el-button>
            <el-button type="primary" @click="addValueCard">{{ $t('Member.add_card') }}</el-button>
            <el-button type="primary" @click="depositCharge">{{ $t('Charge.title1') }}</el-button>
            <el-button type="primary" @click="sendMsg">{{ $t('Member.Send') }}</el-button>
        </template>
        <el-table
            border
            v-if="tableData"
            :data="tableData"
            ref="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
        >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="id" :label="$t('Card.client_id')" align="center" width="100px" v-if="false"/>
            <el-table-column prop="editorNickname" :label="$t('Member.Desc.entry')" align="center"/>
            <el-table-column prop="createdAt" :label="$t('Client.entry_date')" align="center" width="150px"/>
            <el-table-column prop="mshpSalesNickname" :label="$t('Common.saler')" align="center"/>
            <el-table-column prop="name" :label="$t('Card.client_name')" align="center"/>
            <el-table-column prop="gender" :label="$t('Common.gender')" align="center" />
            <el-table-column prop="phone" :label="$t('Common.phone_number')" align="center"/>
            <el-table-column prop="channelSource" :label="$t('Client.Add.get_attributes')" align="center"/>
            <el-table-column prop="channelAttr" :label="$t('Client.Add.attributes')" align="center">
                <template slot-scope="{row}">
                    <span style="color:#ce6969 ">{{ row.channelAttr }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="followLevel" :label="$t('Client.Add.follow_level')" align="center"/>
            <el-table-column prop="category" :label="$t('Client.Add.customer_type')" align="center"/>
            <el-table-column prop="clientTagNames" :label="$t('Client.Add.customer_label')" align="center"/>
            <el-table-column prop="activeName" :label="$t('Client.Add.status')" align="center"/>
            <el-table-column prop="active" :label="$t('Client.Customer')" align="center" v-if="!tableData"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>

        <!-- 入会操作 -->
        <mshp-contract-form ref="mspContract" :type="1" :isDeposit="false" @refreshData="refreshData" />
        <!-- 收取定金 -->
        <deposit-charge ref="charge" />
        <!-- 收取押金 -->
        <!-- <deposit-collection ref="collection" /> -->
        <send-message-form ref="sendMessage" />
        <new-contract
            @close="visible = false"
            v-if="visible"
            ref="newContract"
            :activeName="activeName"
            :infoType="infoType"
            :data="client"
            :contract="contract"
            :isDeposit="false"/>
    </el-card>
</template>

<script>
import { Dialog } from 'element-ui';
import MshpContractForm from '@/components/Dialog/Client/MshpContractForm';
import SendMessageForm from '@/components/Dialog/Client/SendMessageForm';
import NewContract from '@/components/Dialog/Client/NewContract';
import DepositCharge from '@/components/Dialog/Client/DepositCharge';
// import DepositCollection from '@/components/Dialog/Client/DepositCollection';

export default {
    props: ['activeName', 'ids', 'clientId'],
    components: {
        ElDialog: Dialog,
        MshpContractForm,
        SendMessageForm,
        NewContract,
        DepositCharge,
        // DepositCollection,
    },
    data() {
        return {
            contract: {name: 'storeValue'},
            loading: false,
            tableData: [],
            clientIds: [],
            clients: [],
            form: {
                mshpSalesId: '',
                createdAtStart: '',
                createdAtEnd: '',
                active: '',
                editorId: '',
                categoryCode: '',
                clientTagIds: [],
                followLevelCode: '',
                channelSourceCode: '',
                channelAttrCode: '',
                age: '',
                genderCode: '',
                birthdayStart: '',
                birthdayEnd: '',
                hasAvatar: '',
                marriageCode: '',
                childrenCode: '',
                infoHabitCode: '',
                personalHobbyCode: '',
                joinedClubCode: '',
                joinedClubBrand: '',
                fitnessPurposeCode: '',
                wasFitnessMemberCode: '',
                leftReasonCode: '',
                keyword: '',
            },
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            visible: false,
            infoType: 3,
            client: null,
        };
    },
    watch: {
        activeName(val) {
            if (val === 'first') this.fetchData();
        },
        'clientId'(val) {
            if (this.activeName === 'first') this.fetchData();
        },
    },
    methods: {
        // 打开入会合同确认框架
        refreshData(val) {
            this.fetchData();
            this.$emit('update:activeName', 'second');
        },
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            const tagIds = this.form.clientTagIds;
            const contractStoreIds = this.form.contractStoreIds;
            this.$delete(this.form, 'clientTagIds');
            API.get('client/potential/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                    clientTagIds: tagIds ? tagIds.join(',') : null,
                    clientIds: this.clientId ? this.clientId : '',
                    contractStoreIds: contractStoreIds ? contractStoreIds.join(',') : null,
                },
            })
            .then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        say(data) {
            if (data) this.form = data;
            this.fetchData();
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        handleSelectChange(val) {
            this.clientIds = val.map(el => el.id);
            this.clients = val;
            this.$emit('listenClientIds', this.clients);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        createMshpContract() {
            if (this.validSingleSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.$refs.mspContract.open(this.clients[0].id);
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        validSingleSelect() {
            if (this.clientIds.length > 1) $ele.$message.warning(this.$t('Common.message.onlyoperationone'));
            else if (this.clientIds.length < 1) $ele.$message.warning(this.$t('Common.message.Pleaseselectonetodo'));
            else return true;
        },
        sendMsg() {
            if (this.clientIds.length && this.$$filterPermission('客户-客户/会员管理-发短信'))
            this.$refs.sendMessage.open(this.clientIds);
            else if (!this.clientIds.length) $ele.$message.warning(this.$t('Message.choose_once'));
        },
        addValueCard() {
            if (this.validSingleSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.client = this.clients[0].id;
                    this.visible = true;
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 收取定金
        depositCharge() {
            if (this.validSingleSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.$refs.charge.open(this.clients[0]);
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
    },
    created() {
        this.fetchData();
    },
};
</script>
<style lang="scss">
.potential-client {
    .el-date-editor--datetimerange.el-input,
    .el-date-editor--datetimerange.el-input__inner {
        width: 100%;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 100%;
    }
    .el-select {
        width: 100%;
    }
    .el-form-item {
        padding-right: 20px;
    }
}
</style>
